<template>
  <div class="azcon-slider-skeleton">
    <div class="azcon-slider-skeleton__image"></div>
    <div class="azcon-slider-skeleton__dots">
      <span v-for="i in 3" :key="i" class="azcon-slider-skeleton__dot"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AzconSliderSkeleton",
};
</script>

<style lang="scss" scoped>
.azcon-slider-skeleton {
  position: relative;
  margin-top: 10px;
  border-radius: 12px;
  overflow: hidden;
  background: #e8edf3;

  &__image {
    width: 100%;
    aspect-ratio: 2048 / 517;
    background: linear-gradient(90deg, #e8edf3 25%, #dce3eb 50%, #e8edf3 75%);
    background-size: 200% 100%;
    animation: azcon-shimmer 1.5s infinite;
  }

&__dots {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
  }

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.25);
  }
}

@keyframes azcon-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* Mobile Landscape */
@media (max-width: 768px) {
  .azcon-slider-skeleton__image {
    aspect-ratio: 16 / 7;
  }

  .azcon-slider-skeleton__dots {
    bottom: 6px;
  }
}

/* Mobile Portrait */
@media (max-width: 576px) {
  .azcon-slider-skeleton {
    border-radius: 10px;
  }

  .azcon-slider-skeleton__image {
    aspect-ratio: 16 / 9;
  }

  .azcon-slider-skeleton__dots {
    bottom: 4px;
  }

  .azcon-slider-skeleton__dot {
    width: 6px;
    height: 6px;
  }
}

/* Extra Small */
@media (max-width: 400px) {
  .azcon-slider-skeleton__image {
    aspect-ratio: 16 / 10;
  }
}
</style>
